import * as React from 'react';
export const bbbankSvg = React.forwardRef(function bbbankSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EBF1F7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#bi_bbbank__a)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M3.49 9.222v-.495h3.812c1.425 0 2.24.655 2.24 1.891 0 .99-.582 1.746-1.891 1.804 1.396.072 2.269.829 2.269 2.109 0 1.309-.99 1.978-2.618 1.978H3.49v-.51h.873V9.223H3.49Zm7.274 0v-.495h3.81c1.44 0 2.255.655 2.255 1.891 0 .99-.596 1.746-1.92 1.804 1.411.072 2.284.829 2.284 2.109 0 1.309-.975 1.978-2.619 1.978h-3.81v-.51h.872V9.223h-.872Zm-4.844.145h.8c.742 0 1.236.553 1.236 1.397 0 .814-.523 1.425-1.207 1.425H5.92V9.367Zm8.087 0h-.814v2.822h.843c.684 0 1.193-.61 1.193-1.425 0-.844-.48-1.397-1.222-1.397ZM5.92 12.858h.873c.96 0 1.585.626 1.585 1.586 0 1.018-.582 1.556-1.673 1.556H5.92v-3.142Zm8.13 0h-.857V16h.785c1.091 0 1.673-.538 1.673-1.556 0-.96-.626-1.586-1.6-1.586Z',
        fill: '#000',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M24.073 5.818c.029.378.029.916.029 1.426 0 7.534-5.818 13.832-13.92 14.036v4.902c10.32-.023 18.709-8.328 18.836-18.648 0-.581 0-1.25-.029-1.716h-4.916Z',
        fill: '#2E4C9B',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'bi_bbbank__a',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'matrix(1 0 0 -1 3.49 26.182)',
          d: 'M0 0h25.527v20.364H0z',
        }),
      ),
    ),
  );
});
bbbankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bbbank = {
  category: 'brand',
  colorable: false,
  name: 'bbbank',
  svg: bbbankSvg,
};
